import {
  ComponentType,
  ForwardedRef,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef
} from 'react';

import styles from '../../../index.module.css';

interface SnippetSlideProps {
  handleClickOnMove: (event: MouseEvent) => void;
  gap?: number | string;
  snippetId: string;
  HTMLSnippet: ComponentType<{ snippetId: string }>;
}

export const SnippetSlide = forwardRef<HTMLDivElement, SnippetSlideProps>(
  (
    { handleClickOnMove, gap, snippetId, HTMLSnippet },
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const slideRef = useRef<HTMLDivElement>(null);

    useImperativeHandle(ref, () => slideRef.current || ({} as HTMLDivElement));

    useEffect(() => {
      const currentRef = slideRef?.current;

      if (!currentRef) {
        return () => {};
      }

      const handleClick = (ev: MouseEvent) => {
        handleClickOnMove(ev);
      };

      currentRef.addEventListener('click', handleClick, true);

      return () => {
        currentRef.removeEventListener('click', handleClick, true);
      };
    }, [handleClickOnMove]);

    return (
      <div
        className={styles.snippetBox}
        ref={slideRef}
        style={gap ? { marginRight: gap } : undefined}
      >
        <HTMLSnippet snippetId={snippetId} />
      </div>
    );
  }
);
